import { render, staticRenderFns } from "./YoneticiTanimla.vue?vue&type=template&id=03647a3c&scoped=true&"
import script from "./YoneticiTanimla.vue?vue&type=script&lang=js&"
export * from "./YoneticiTanimla.vue?vue&type=script&lang=js&"
import style0 from "./YoneticiTanimla.vue?vue&type=style&index=0&id=03647a3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03647a3c",
  null
  
)

export default component.exports